const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY

export * from './provinces.json'

export const GOOGLE_MAP_API_URL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_API_KEY}`

export const GOOGLE_MAP_STATIC_URL = `https://maps.googleapis.com/maps/api/staticmap?center={LOCATION}&zoom=12&size=400x100&maptype=roadmap&markers=color:red%7C{LOCATION}&key=${GOOGLE_API_KEY}`

export const HeroType = {
  RECYCLE_SHOP: {
    title: 'ร้านรับซื้อขยะรีไซเคิล'
  },
  SCOOTER: {
    title: 'รถรับซื้อขยะรีไซเคิลถึงที่'
  },
  DROP_POINT: {
    title: 'จุดรับบริจาคขยะรีไซเคิล'
  },
  POSTAL: {
    title: 'รับขยะรีไซเคิลทางพัสดุ'
  },
  CIRCULAR_BIN: {
    title: 'Circular Bin'
  },
  FACTORY: {
    title: 'โรงงานรีไซเคิล'
  }
}

export const DEFAULT_LOCATION = {
  lat: 18.79108,
  lng: 98.9833963
}



// WEBPACK FOOTER //
// ./src/config/index.js